import { useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { CustomerAssortmentDTO, PostCustomerAssortmentDTO } from '@retail/customer-discount/types';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

export function useCreateCustomerAssortment(queryOptions: QueryOptions = {}) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<CustomerAssortmentDTO, PostCustomerAssortmentDTO>({
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.customerAssortments.getFullLinkPath(),
    }),
    method: 'POST',
    token,
    ...queryOptions,
  });
}
